/// <amd-module name="TFS/Views/ProjectOverviewPage/AboutProjectPanel/AboutProjectPanelOverlay" />
import * as React from "react";

import { FocusTrapZone } from "OfficeFabric/FocusTrapZone";
import { Overlay } from "OfficeFabric/Overlay";
import { Button } from "VSSUI/Button";
import { Icon } from "VSSUI/Icon";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

import * as Resources from "TFS/Views/ProjectOverviewPage/AboutProjectPanel/Resources";

interface IAboutProjectPanelOverlayProps {
    showSaving: boolean;
    descriptionError: string | undefined;
    onCtaButtonClick: () => void;
}

export const AboutProjectPanelOverlay = (props: IAboutProjectPanelOverlayProps): JSX.Element => {
    const { showSaving, descriptionError, onCtaButtonClick } = props;
    const ctaButtonClassName = "cta-button";
    return (
        <Overlay className={"about-project-panel-overlay transparent-panel flex"}>
            <FocusTrapZone
                className="flex-row flex-grow"
                ignoreExternalFocusing={true}
                firstFocusableSelector={showSaving ? undefined : ctaButtonClassName}
            >
                <div className={"overlay-content-wrapper flex flex-column flex-center justify-center"}>
                    {showSaving ? (
                        <Spinner size={SpinnerSize.large} className={"status-message-spinner"} />
                    ) : (
                        <Icon className={"warning-icon font-size-xl"} iconName={"Warning"} />
                    )}
                    <span className={"title title-xs"}>
                        {showSaving ? Resources.AboutProjectChangesSavingTitle : Resources.AboutProjectGenericErrorTitle}
                    </span>
                    <span className={"description"}>
                        {showSaving ? (
                            Resources.AboutProjectChangesSavingSubtitle
                        ) : descriptionError ? (
                            <>
                                {descriptionError}
                                <br />
                                {Resources.AboutProjectPanelGoBackText}
                            </>
                        ) : (
                            <>
                                {Resources.AboutProjectGenericErrorSubtitle}
                                <br />
                                {Resources.AboutProjectPanelTryAgainText}
                            </>
                        )}
                    </span>
                    {!showSaving && (
                        <Button
                            primary={true}
                            className={ctaButtonClassName}
                            text={descriptionError ? Resources.AboutProjectPanelGoBackButtonText : Resources.AboutProjectPanelTryAgainButtonText}
                            onClick={onCtaButtonClick}
                        />
                    )}
                </div>
            </FocusTrapZone>
        </Overlay>
    );
};
